<div class="tw-mb-4">
  <app-cipher-view
    [cipher]="cipher()"
    [hasAnonymousPremium]="true"
    [hideItemHistory]="true"
  ></app-cipher-view>
</div>
